//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum OrganizationInvitationStatuses {
    New = 1,
    Accepted = 2,
    Rejected = 3,
    Canceled = 4,
}
